import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, } from '@angular/forms';

@Component({
  selector: 'app-mat-hotel-guest',
  templateUrl: './mat-hotel-guest.component.html',
  styleUrls: ['./mat-hotel-guest.component.scss']
})
export class MatHotelGuestComponent implements OnInit {
  step = 0;
  rooms = 1;
  adults = 2;
  guest_number = [0];
  adult_child_room: FormGroup;
  no_guest = new FormControl('2');
  no_room = new FormControl('1');
  constructor(private fb: FormBuilder,) { }

  ngOnInit(): void {
    this.adult_child_room = this.fb.group({
      // adult_count_number: new FormControl('2'),
      guest_room_add: this.fb.array([this.initDos()])
    })
  }

  submit() {
    if(this.adult_child_room.valid){
      console.log(this.adult_child_room.value);

    }
  }

  setStep(index: number) {
    this.step = index;
  }

  counter_room (type: string) {
    type==='add_room' ?this.rooms++:this.rooms--;
  }


  get dosArray() {
    return this.adult_child_room.get('guest_room_add') as FormArray;
  }

  initDos() {
    return this.fb.group({
      adult_count_number: new FormControl(''),
    })
  }
  add_room() {
    this.dosArray.push(this.initDos());
    this.guest_number.push(Math.floor(Math.random() *1000));
  }

  remove_room(index) {
    this.dosArray.removeAt(index);
  }

  counterAdult(i) {
    if(this.adults > 1)
    this.adults--;
  }
  counterAdults(i) {
    if(this.adults < 4)
    this.adults++;
  }

}
